import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Nav, NavItem, NavLink, Spinner } from "reactstrap";
import classnames from "classnames";
import ApiService from "../services/ApiService";
import { format } from "date-fns";
import { connect } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";


const VisibilityGraph = ({
  date,
  tenant,
  overrideTenantId,
  useSourceFilter = false,
  total,
}) => {

const getChartOptions = (graphs, activeTab, useSourceFilter, filter, total) => {
  const graph = graphs[activeTab] || { data: { series: [] } };
  const series = useSourceFilter
    ? graph.data.series.filter((serie) => serie.source === filter)
    : graph.data.series;
  if (total) {
    series.unshift({
      color: "#2B95BA",
      dashStyle: "dot",
      data: series
        .filter((serie) => serie.variant === "sum")
        .reduce((acc, serie) => {
          return serie.data.map((value, index) => {
            return (acc[index] || 0) + value;
          });
        }, []),
      name: "Total",
      source: filter,
    });
  }
  return {
    credits: { enabled: false },
    chart: {
      type: "spline",
    },
    title: {
      text: "",
    },
    yAxis: {
      DashStyle: "ShortDash",
      title: {
        text: graph.data.yTitle,
      },
      labels: {
        style: {
          color: 'var(--text-primary)'
       }
      }
    },
    xAxis: {
      categories: graph?.data?.labels,
      labels: {
        style: {
          color: 'var(--text-primary)'
       }
      },
      DashStyle: "ShortDash",

      title: {
        text: graph?.data?.xTitle,
        style: {
          color: 'var(--text-primary)'
       }
      },
    },
    series: JSON.parse(JSON.stringify(series)),
  };
};

  const { startDate, endDate } = date;
  const enabled = !!(date.startDate && date.endDate);
  let since;
  let until;
  if (enabled) {
    since = format(date.startDate, "yyyy-MM-dd");
    until = format(date.endDate, "yyyy-MM-dd");
  }
  const {
    data: graphs,
    isLoading,
    isRefetching,
    isSuccess,
  } = useQuery({
    queryKey: ["visibility", tenant.id, overrideTenantId, startDate, endDate],
    queryFn: () => ApiService.getVisibility(overrideTenantId, since, until),
    select: (data) => data.data.graphs,
    enabled,
    placeholderData: { data: { graphs: [] } },
  });
  const [activeTab, setActiveTab] = useState(1);// default to monthly
  
  const [filter, setFilter] = useState("facebook");
  const [chartOptions, setChartOptions] = useState(
    getChartOptions(graphs, activeTab, useSourceFilter, filter, total)
  );

  useEffect(() => {
    setChartOptions(
      JSON.parse(
        JSON.stringify(
          getChartOptions(graphs, activeTab, useSourceFilter, filter, total)
        )
      )
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, graphs, useSourceFilter, filter, total]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const renderTab = (graph, index) => {
    return (
      <NavItem key={index}>
        <NavLink
          href="#"
          className={classnames({ active: activeTab === index })}
          onClick={() => toggleTab(index)}
        >
          {graph.source}
        </NavLink>
      </NavItem>
    );
  };

  return (
    <>
      {(isLoading || isRefetching) && (
        <Spinner
          color="primary"
          size="sm"
          style={{ position: "absolute", right: 20 }}
        />
      )}
      {isSuccess && (
        <>
          <Nav pills className="navtab-bg my-4 center-pills">
            {graphs.map((graph, index) => renderTab(graph, index))}
          </Nav>
          {useSourceFilter && (
            <Nav pills className="navtab-bg my-4 center-pills">
              <NavItem>
                <NavLink
                  href="#"
                  className={classnames({ active: filter === "facebook" })}
                  onClick={() => setFilter("facebook")}
                >
                  Facebook
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#"
                  className={classnames({ active: filter === "instagram" })}
                  onClick={() => setFilter("instagram")}
                >
                  Instagram
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="#"
                  className={classnames({ active: filter === "web" })}
                  onClick={() => setFilter("web")}
                >
                  Web
                </NavLink>
              </NavItem>
            </Nav>
          )}
          {graphs[activeTab] && (
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  date: state.date,
  tenant: state.auth.tenant,
});

export default connect(mapStateToProps)(VisibilityGraph);
